module.exports = __webpack_public_path__ + "static/media/Jean_Paul_Becerril_Celis.d187bd4a.png";